import { Link } from 'react-router-dom'
import { api } from '../api/client'
import { Icon } from '../components/Icon'
import { Empty, ErrorState, Loading } from '../components/States'
import { initials, relativeDays, titleCase } from '../lib/format'
import { tint } from '../lib/tint'
import { useAsync } from '../lib/useAsync'

/** Recent texts and emails in both directions, replies first in mind: an inbound
 *  message is what an officer must not miss. Opening one goes to the contact. */
export function Inbox() {
  const { data, error, loading, reload } = useAsync(() => api.inbox(), [])
  const messages = data?.messages ?? []
  const replies = messages.filter((m) => m.direction === 'inbound').length

  return (
    <div className="page" style={{ maxWidth: 980 }}>
      <div className="page-head">
        <div>
          <h1 className="h1">Inbox</h1>
          <p className="subline">
            {replies} repl{replies === 1 ? 'y' : 'ies'} · texts and emails from the lead platform and the CRM
          </p>
        </div>
        <button className="btn" onClick={reload}><Icon name="refresh" size={17} /> Refresh</button>
      </div>

      <section className="card">
        {loading && !data ? (
          <Loading />
        ) : error ? (
          <ErrorState error={error} onRetry={reload} />
        ) : messages.length === 0 ? (
          <Empty title="No messages yet">Texts and emails you send, and replies to them, collect here.</Empty>
        ) : (
          messages.map((m) => {
            const inbound = m.direction === 'inbound'
            const row = (
              <>
                <span className="qav" style={tint(m.contact_name)}>{initials(m.contact_name)}</span>
                <span className="qmid">
                  <span className="qname-row">
                    <span className="qname">{m.contact_name ?? 'Unknown contact'}</span>
                    <span className={`badge ${inbound ? 't-positive' : 't-neutral'}`}>
                      <Icon name={inbound ? 'call_received' : 'call_made'} size={12} style={{ verticalAlign: -2 }} />{' '}
                      {m.channel === 'sms' ? 'Text' : titleCase(m.channel)}
                    </span>
                    {m.status && !inbound ? <span className="quiet" style={{ fontSize: 11.5 }}>{titleCase(m.status)}</span> : null}
                  </span>
                  <span className="qdetail" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                    {m.body ?? '—'}
                  </span>
                </span>
                <span className="mono" style={{ fontSize: 11.5, color: 'var(--ink-3)', whiteSpace: 'nowrap' }}>
                  {relativeDays(m.occurred_at)}
                </span>
              </>
            )
            return m.contact_id ? (
              <Link key={m.id} to={`/contacts/c/${m.contact_id}`} className="qrow" style={{ color: 'inherit' }}>{row}</Link>
            ) : (
              <div key={m.id} className="qrow">{row}</div>
            )
          })
        )}
      </section>
    </div>
  )
}
